import { useMutation, useQueryClient } from "@tanstack/react-query";

import { patchEmail } from "@/api/emails";

interface UpdateArgs {
  id: string;
  tradeKey?: string | null;
}

export function useUpdateEmail() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...patch }: UpdateArgs) => patchEmail(id, patch),
    onSuccess: (data) => {
      qc.setQueryData(["email", data.id], data);
      void qc.invalidateQueries({ queryKey: ["emails"] });
    },
  });
}
